<template lang="html">
  <div class="content">
    <HeadModule :openTarget="'shortVideo/detail?id=' +cid+ '&type=' +cType" />
    <div class="txt_content">
      <div class="">
        <VideoPlayer :options="videoOptions" />
      </div>
      <div class="film_tv_mod">
        <!-- <div class="open_APP_btn">
          打开APP查看更多
          <WxOpenTag :extinfo="'shortVideo/detail?id=' +cid+ '&type=' +cType" />
        </div> -->

        <div class="film_tv_title">
          <p v-show="microVideo.original_type == 1">原创</p>
          <span>{{microVideo.title}}</span>
        </div>
        
        <div class="film_data">
          <div class="film_userHerder">
            <img :src="microVideo.avatar" alt="">
            <p>{{ microVideo.username }}</p>
          </div>
          <p class="film_hitnum">{{ microVideo.hitnum }}人浏览</p>
        </div>

        <div class="attention" v-show="microVideo.original_type == 1">
          「本文为作者原创文章，未经授权禁止转载」
        </div>
      </div>
    </div>

    <div class="correlation_video_mod">
      <h3>相关视频</h3>
      <div class="module" v-for="(a, index) in correlation_video.slice(0, 3)" :key="index">
        <img :src="a.pic" alt="" class="">
        <div class="module_con">
          <p class="module_title">{{a.title}}</p>
          <div class="module_teacher">
						<div class="module_teacher_header">
							<img :src="a.avatar" alt="">
							<span>{{a.username}}</span>
						</div>
						<p >{{ a.hitnum }}人浏览</p>
					</div>
        </div>
      </div>
      <WxOpenTag :extinfo="'shortVideo/detail?id=' +cid+ '&type=' +cType" />
    </div>

    <div class="commentMod" v-show="microVideo.postnum > 0">
      <CommentMod :commentNum="commentNums" :comments="uesr_comment" :jumpTarget="jumpTarget" />
    </div>
    
    <div class="callAppIcon" v-show="callApp">
      <img src="../../../assets/image/icon/ic_button.png" alt="">
      <WxOpenTag ref="wxopentag" :extinfo="'shortVideo/detail?id=' +cid+ '&type=' +cType" />
    </div>

    <div class="topIcon" v-show="topPost">
			<img src="../../../assets/image/icon/ic_top.png" alt="" @click="getTopBtn">
		</div>
  </div>
</template>

<script>
  import utils from '@/utils/utils'
  import HeadModule from '@/components/HeadModule'
  import WxOpenTag from '@/components/WxOpenTag'
  import CommentMod from '../CommentMod'
  import WxShare from '@/utils/wxshare';

  import VideoPlayer from '@/components/VideoPlayer'

  export default {
    components: {
      HeadModule: HeadModule,
      CommentMod: CommentMod,
      VideoPlayer: VideoPlayer,
      WxOpenTag: WxOpenTag,
    },

    data() {
      return {
        cid: this.$route.query.id || '',
        cType: this.$route.query.type || '',
        microVideo: {},
        comment: [],
        videoOptions: {},

        correlation_video: [],

        // 组件参数
        commentNums: '',
        uesr_comment: [],
        jumpTarget: `shortVideo/detail?id=${this.$route.query.id}&type=${this.$route.query.type}`,
        callApp: false,
        topPost: false,
      }
    },

    mounted() {
      document.title = '电巢短视频';
      this.micro_video();
      window.addEventListener('scroll', this.handleScroll);
      window.addEventListener('scroll', this.getTopPost);
    },

    methods: {
      // 时间戳转化
      timestampToTime(type, cjsj) {
        var date = new Date(cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        if (type == 1) {
          var M_ = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '月'
          var D_ = date.getDate() + '日'
          return M_ + D_
        } else {
          var Y = date.getFullYear() + '-'
          var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
          var D = date.getDate() + ' '
          var h = date.getHours() + ':'
          var m = date.getMinutes() + ':'
          var s = date.getSeconds()
          return Y + M + D + h + m + s
        }
      },
      // 电巢短视频
      micro_video() {
        this.$http({
          url: '/edu/openCourseDetail',
          method: 'get',
          params: {
            course_id: this.$route.query.id,
            type: this.$route.query.type
          },
        }).then((res) => {
          if (res.code >= 0) {
            this.microVideo = res.data;
            this.micro_video_comment(this.microVideo.unique_id);

            this._correlation_video(this.microVideo.categoryid);

            this.commentNums = res.data.postnum;

            new WxShare().share({
              title: this.microVideo.title || `${this.microVideo.username}发布的视频`,
              desc: '电子产业链一站式数字化服务平台，电子人学习、工作、认证的孵化巢',
              link: window.location.href,
              imgUrl: this.microVideo.pic,
            })

            this.videoOptions = {
              poster: res.data.pic,
              sources: [{
                src: utils.au(res.data.play_url),
                type: 'video/mp4'
              }]
            }
          }
        })
      },
      // 相关视频
      _correlation_video(id) {
        this.$http({
          url: '/edu/weishi',
          method: 'get',
          params: {
            limit: 3,
            cid: id,
            except_id: this.$route.query.id,
          },
        }).then((res) => {
          if (res.code == 0) {
            this.correlation_video = res.data;
          } else {
            return;
          }
        })
      },

      // 评论
      micro_video_comment(id) {
        this.$http({
          url: '/edu/comment',
          method: 'get',
          params: {
            course_id: id,
            type: this.$route.query.type || 0,
            start: 0,
            limit: 2,
          },
        }).then((res) => {
          this.comment = res.data;
          this.uesr_comment = res.data;
        })
      },

      // 监听打开app按钮显示隐藏
			handleScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.callApp = true;
        } else {
          this.callApp = false;
        }
      },

      getTopPost() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        if (scrollTop > 56) {
          this.topPost = true;
        } else {
          this.topPost = false;
        }
      },

      getTopBtn() {
				window.scroll(0, 0);
			},
    }
  }
</script>

<style lang="css" scoped>
  .content {
    background-color: #F7F8F8;
  }

  .film_tv_mod {
    padding: 20px 15px;
    background-color: #fff;
  }

  .film_tv_title {
    font-size: 1.5rem;
  }

  .film_tv_title p {
		position: relative;
		top: -.2rem;
		box-sizing: border-box;
		background-color: #FFDAD8;
		color: #F7443F;
		display: inline;
		font-size: 1.1rem;
		padding: .25rem .5rem;
		margin-right: .5rem;
		border-radius: .2rem;
	}

  .film_data {
    margin-top: 1rem;
    font-size: 10px;
    display: flex;
    justify-content: space-between;
  }

  .film_userHerder {
    display: flex;
    align-items: center;
    font-size: 1.2rem;
    font-weight: 600;
    color: #333333;
  }

  .film_userHerder img {
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 50%;
    margin-right: .5rem;
    border: .05rem solid #E5E6EB;
  }
  
  .attention {
    font-size: 1.3rem;
    color: #F7443F;
    margin-top: 1.5rem;
    text-align: center;
  }

  .film_collect_data {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #606972;
  }

  .film_collect_data img {
    margin-right: 4px;
  }

  .film_hitnum {
    font-size: 1.2rem;
    color: #555555;
  }

  .film_comment_data {
    position: relative;
    display: flex;
    align-items: center;
    margin-left: 10px;
    color: #606972;
  }

  .film_comment_data img {
    margin-right: 4px;
  }



  .correlation_video_mod {
    position: relative;
    margin-top: 10px;
    background-color: #fff;
    padding: 15px;
  }

  .module {
    padding: 12px 0;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid rgba(0, 0, 0, 0.1);
  }

  .module:nth-last-child(2) {
    border-bottom: none;
  }

  .module img {
    width: 13.3rem;
    height: 80px;
    border-radius: 5px;
    object-fit: cover;
    border: .05rem solid #E5E6EB;
  }

  .module_con {
    width: 58%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .module_title {
    color: #1D2023;
    font-size: 16px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  .module_teacher {
    display: flex;
    justify-content: space-between;
    font-size: 1.2rem;
    color: #606972;
  }

  .module_teacher p{
    color: #999999;
  }

  .module_teacher_header {
		display: flex;
		align-items: center;
	}

	.module_teacher_header img {
		width: 1.95rem;
		height: 1.95rem;
		border-radius: 50%;
		object-fit: cover;
		margin-right: .5rem;
    border: .05rem solid #E5E6EB;
	}

  .clod_app_btn {
    color: #2086FC;
    font-size: 12px;
  }

  /* 下载按钮 */
  .open_APP_btn {
    position: relative;
    margin-top: 10px;
    margin-left: 15px;
    margin-right: 15px;
    border-radius: 3px;
    height: 35px;
    line-height: 35px;
    background-color: #E50120;
    text-align: center;
    color: #FCFCFC;
    font-size: 16px;
  }

  .commentMod {
    margin-top: 1rem;
  }

  .callAppIcon {
    position: fixed;
    right: 0;
    bottom: 10.6rem;
    z-index: 10;
  }

  .callAppIcon img {
    width: 11.1rem;
    height: 3.35rem;
  }

  .topIcon {
		position: fixed;
		right: 1.1rem;
		bottom: 3rem;
		z-index: 11;
	}

  .topIcon img {
    width: auto;
    height: 4.15rem;
  }
</style>